module.exports = __webpack_public_path__ + "images/doc-list-af4142c62aa9a88fd23670a61b77d1e4.png";